import theme from '../../../lib/theme';
import { TitleBlockProps } from './TitleBlock';

const { layouts, scale, media, colors, font } = theme;

export default ({}: TitleBlockProps) => ({
  container: {},

  pageTitle: {
    color: colors.black,
    margin: '0 !important',
    fontWeight: 700,
    fontFamily: font.families.primary,
  },
});
